import { render } from "./LoggingList.vue?vue&type=template&id=088a2084&scoped=true"
import script from "./LoggingList.vue?vue&type=script&lang=js"
export * from "./LoggingList.vue?vue&type=script&lang=js"

import "./LoggingList.vue?vue&type=style&index=0&id=088a2084&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088a2084"]])

export default __exports__